import { type SxProps, type Theme } from '@mui/material';

export const sx = {
  root: (t) => ({
    display: 'flex',
    width: '100%',

    [t.breakpoints.only('sm')]: {
      mx: -24,
      width: 'unset',
    },
    [t.breakpoints.only('xs')]: {
      mx: -16,
      width: 'unset',
    },
  }),

  table: {
    position: {
      lg: 'relative',
    },
  },

  tableHead: (t) => ({
    position: {
      lg: 'sticky',
    },
    top: {
      lg: 0,
    },
    backgroundColor: {
      lg: t.palette.background.default,
    },
  }),

  tableHeaderCell: {
    position: {
      sm: 'relative',
    },
  },

  resultCell: {
    width: {
      lg: 120,
      sm: 156,
      xs: 120,
    },
  },

  resultCellFewDocuments: {
    width: {
      lg: 120,
      sm: 108,
      xs: 120,
    },
  },

  tableHeaderText: {
    typography: {
      xs: '12_16_700',
      sm: '16_20_800',
    },
  },

  tableBodyRow: (t) => ({
    backgroundColor: t.palette.background.default,
  }),

  tableBodyText: {
    typography: {
      xs: '12_16_600',
      sm: '14_18_600',
    },
    wordBreak: 'break-word',
  },
} satisfies Record<string, SxProps<Theme>>;
